import i18n from "@/locale/locale.config";

export function validateName(value: string): boolean {
  return /\b[A-Za-zÀ-ú][A-Za-zÀ-ú]+,?\s[A-Za-zÀ-ú][A-Za-zÀ-ú]{2,19}\b/gi.test(
    value
  );
}

export function validateCPF(cpf: string): boolean {
  cpf = cpf.replace(/[^\d]+/g, "");
  if (cpf == "") return false;
  if (
    cpf.length != 11 ||
    cpf == "00000000000" ||
    cpf == "11111111111" ||
    cpf == "22222222222" ||
    cpf == "33333333333" ||
    cpf == "44444444444" ||
    cpf == "55555555555" ||
    cpf == "66666666666" ||
    cpf == "77777777777" ||
    cpf == "88888888888" ||
    cpf == "99999999999"
  )
    return false;

  // First digit
  var add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
  var rev = 11 - (add % 11);
  if (rev == 10 || rev == 11) rev = 0;
  if (rev != parseInt(cpf.charAt(9))) return false;
  // Second digit
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev == 10 || rev == 11) rev = 0;
  if (rev != parseInt(cpf.charAt(10))) return false;
  return true;
}
export function validCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj == "") return false;

  if (cnpj.length != 14) return false;

  if (
    cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999"
  )
    return false;

  var length = cnpj.length - 2;
  var numbers = cnpj.substring(0, length);
  var digits = cnpj.substring(length);
  var sum = 0;
  var pos = length - 7;
  for (var i = length; i >= 1; i--) {
    sum += numbers.charAt(length - i) * pos--;
    if (pos < 2) pos = 9;
  }
  var result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result != digits.charAt(0)) return false;

  length = length + 1;
  numbers = cnpj.substring(0, length);
  sum = 0;
  pos = length - 7;
  for (i = length; i >= 1; i--) {
    sum += numbers.charAt(length - i) * pos--;
    if (pos < 2) pos = 9;
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result != digits.charAt(1)) return false;

  return true;
}

function getSvgDimensions(svgElement: Element): {
  width: number;
  height: number;
} {
  const width = parseFloat(svgElement.getAttribute("width") || "0");
  const height = parseFloat(svgElement.getAttribute("height") || "0");
  const viewBox = svgElement.getAttribute("viewBox")?.split(" ").map(Number);

  if (width > 0 && height > 0) {
    return { width, height };
  }

  if (viewBox && viewBox.length === 4) {
    return { width: viewBox[2], height: viewBox[3] };
  }

  return { width: 0, height: 0 };
}

function parseSvgFile(file: File): Promise<Element | null> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const svgString = e.target?.result as string;
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgString, "image/svg+xml");
      const svgElement = svgDoc.querySelector("svg");
      resolve(svgElement);
    };
    reader.onerror = () => resolve(null);
    reader.readAsText(file);
  });
}

async function validImage(
  file: File,
  maxWidth: number,
  maxHeight: number
): Promise<boolean> {
  const svgElement = await parseSvgFile(file);
  if (!svgElement) return false;

  const { width, height } = getSvgDimensions(svgElement);

  const isValidWidth = width <= maxWidth;
  const isValidHeight = height <= maxHeight;

  return isValidWidth && isValidHeight;
}

export function validateImageResolution() {
  return {
    $async: true,
    $message: () => i18n.global.t("validations.validResolution"),
    $validator: async (value: File[]) => {
      if (!value) return { $valid: true };
      const promises = value.map((file: any) =>
        file.image ? true : validImage(file, 1920, 1080)
      );
      const results = await Promise.allSettled(promises);
      const $valid = results.every(
        (file) => file.status === "fulfilled" && file.value === true
      );
      return { $valid };
    },
  };
}

export function validTime(value: string): boolean {
  return /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value);
}
